import React from "react";
import { LayoutSettings } from "../../../../../boxes/LayoutSettings/LayoutSettings";
import { EntityHeader } from "../../../../../widgets/EntityHeader/EntityHeader";
import { Box } from "../../../../../shared/Box/Box";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { getPathParams } from "./utilities";
import styles from "./styles.module.scss";
import { Input } from "../../../../../shared/Input/Input";
import { Textarea } from "../../../../../shared/Textarea/Textarea";
import { InputLabel } from "../../../../../shared/InputLabel/InputLabel";
import { Button } from "../../../../../shared/Button/Button";
import { history } from "../../../../../history";
import { useForm } from "./hooks/useForm";
import { useData } from "./hooks/useData";
import { ContentLoader } from "../../../../../boxes/ContentLoader/ContentLoader";
import { useSubmit } from "./hooks/useSubmit";
import { CircularProgress } from "../../../../../shared/CircularProgress/CircularProgress";
import { SETTINGS_ROUTES } from "../../../../../consts/routes";
import { MAX_PHRASE_LENGTH } from "./config";

export const CreateEdit = () => {
  const { id } = getPathParams();

  const submit = useSubmit();
  const { data, isLoading, isError } = useData();
  const form = useForm(data, submit.initiate);

  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "smsSnippets.createEdit",
  });

  return (
    <LayoutSettings contentClassName={styles.root}>
      <EntityHeader
        withBackBtn
        onBack={() => history.push(SETTINGS_ROUTES.smsSnippets.all())}
        title={id ? t("titleEdit") : t("titleCreate")}
      />
      <ContentLoader isLoading={isLoading}>
        <Box className={styles.content}>
          <div className={styles.row}>
            <div>
              <InputLabel>{t("form.name")} *</InputLabel>
              <Input
                name="name"
                value={form.name.value}
                onChange={form.name.onChange}
                onBlur={form.name.onBlur}
                isError={!!form.name.getError()}
              />
            </div>
            <div>
              <InputLabel>{t("form.title")} *</InputLabel>
              <Input
                name="title"
                value={form.title.value}
                onChange={form.title.onChange}
                onBlur={form.title.onBlur}
                isError={!!form.title.getError()}
              />
            </div>
          </div>
          <div>
            <InputLabel>{t("form.phrase")} *</InputLabel>
            <Textarea
              name="phrase"
              value={form.phrase.value}
              onChange={(e) => {
                if (e.target.value.length > MAX_PHRASE_LENGTH) return;
                form.phrase.onChange(e);
              }}
              onBlur={form.phrase.onBlur}
              isError={!!form.phrase.getError()}
            />
          </div>
          <div className={styles.phraseLength}>
            {form.phrase.value.length} / {MAX_PHRASE_LENGTH}
          </div>
          <div className={styles.footer}>
            <Button onClick={() => history.goBack()} variant="outlined">
              {t("form.cancel")}
            </Button>
            <Button
              onClick={form.submit}
              isDisabled={
                isLoading || !form.dirty || submit.isLoading || isError
              }
              leftAdornment={
                submit.isLoading ? (
                  <CircularProgress size="small" color="white" />
                ) : undefined
              }
            >
              {id ? t("form.save") : t("form.create")}
            </Button>
          </div>
        </Box>
      </ContentLoader>
    </LayoutSettings>
  );
};
